import { useState, useEffect } from 'react';
import { ButtonBasic, SelectExecutor } from "@lk-gtcom/ecomlab-components";
import { TextPage } from '../../../TextPage/TextPage';
import useGeneralStore from '../../../../store/general';
import customHeaders, { getSpace } from '../../../../common/headers';
import { usePushNotifications } from '../../../../common/pushNotification';
import { TitlePage } from '../../../TitlePage/TitlePage';
import './ModalDeleteExecutors.scss'

// Массив всех вариантов выбора
const options = ['Без передачи прав', 'Передать права'];

const ModalDeleteExecutors = ({
    setIsModal,
    availableEmployeesList,
    currentMember,
    setCurrentMember,
    deleteMember
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }

    const [checkValues, setCheckValues] = useState(null)
    const [executor, setExecutor] = useState([])

    const [infoProjectByMember, setInfoProjectByMember] = useState(null)
    const [isVisibleInfo, setIsVisibleInfo] = useState(false)

    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const onClose = () => {
        setCurrentMember(null)
        setIsModal(false)
    }

    // Информация о проектах сотрудника, crm и wiki
    const fetchGetInfoByMember = () => {
        const url = ` https://portals.ecomru.ru/api/clients/author_data?delete_client_id=${currentMember?.id}`

        fetch(url, { method: 'GET', headers: headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    addErrorPush('Произошла неизвестная ошибка')
                    throw new Error('bad attendees response')
                }
            })
            .then(json => {
                setInfoProjectByMember(json)
                setTimeout(() => setIsVisibleInfo(true), 0)
            })
            .catch((e) => console.error(e))
    }

    // Удаление сотрудника
    const fetchChangeAuthor = () => {
        const url = ` https://portals.ecomru.ru/api/clients/change-author`

        const body = JSON.stringify({
            delete_client_id: currentMember?.id,
            new_author: executor?.[0]?.id,
        })

        fetch(url, { body, method: 'PUT', headers: headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    addErrorPush('Произошла неизвестная ошибка')
                    throw new Error('bad attendees response')
                }
            })
            .then(json => {
                deleteMember([currentMember?.id])
            })
            .catch((e) => console.error(e))
    }

    useEffect(() => {
        fetchGetInfoByMember()
    }, []);

    const is_empty_project =
        !infoProjectByMember?.wiki?.data?.length &&
        !infoProjectByMember?.task_projects?.data?.length &&
        !infoProjectByMember?.crm_projects?.data?.length

    return (
        <div className='blackout'
            onClick={(e) => {
                let el = e.target
                if (el.classList.contains('blackout')) {
                    onClose()
                }
            }}>
            <div className='modal-delete-executors'>
                <TitlePage
                    medium
                    title='Вы точно хотите удалить сотрудника из пространства?'
                />

                {isVisibleInfo && <>
                    {is_empty_project ?
                        <TextPage
                            text='Этот сотрудник не участвует в проектах "Wiki", "CRM", "Задачи"'
                        />
                        : <div className='modal-delete-executors__radio-group'>
                            {options.map(option => <label className='modal-delete-executors__label'
                                key={option}>
                                <input
                                    type="radio"
                                    name='radio'
                                    value={option}
                                    checked={checkValues === option}
                                    onChange={(e) => setCheckValues(e?.target.value)}
                                    style={{ marginRight: '8px' }}
                                />
                                <TextPage
                                    text={option}
                                />
                            </label>)}
                        </div>}
                </>}


                {(checkValues === 'Передать права') &&
                    <SelectExecutor
                        executors={executor}
                        setExecutors={setExecutor}
                        executorOptions={availableEmployeesList.filter((el) => el?.id !== currentMember?.id)}
                        title="Выберите нового автора"
                        placeholder="Назначить"
                    />}

                {(checkValues === 'Передать права') && <div className='modal-delete-executors__content'>
                    <div className='modal-delete-executors__list-project'>
                        <TitlePage
                            medium
                            title={`Wiki: ${infoProjectByMember?.task_projects?.data?.length ? '' : '-'}`}
                        />

                        {infoProjectByMember?.wiki?.data.map((data) => {
                            return <div className='modal-delete-executors__card-project'>{data}</div>
                        })}
                    </div>

                    <div className='modal-delete-executors__list-project'>
                        <TitlePage
                            medium
                            title={`Задачи: ${infoProjectByMember?.task_projects?.data?.length ? '' : '-'}`}
                        />
                        {infoProjectByMember?.task_projects?.data.map((data) => {
                            return <div className='modal-delete-executors__card-project modal-delete-executors__card-project_green'>{data}</div>
                        })}
                    </div>

                    <div className='modal-delete-executors__list-project'>
                        <TitlePage
                            medium
                            title={`CRM: ${infoProjectByMember?.crm_projects?.data?.length ? '' : '-'}`}
                        />

                        {infoProjectByMember?.crm_projects?.data.map((data) => {
                            return <div className='modal-delete-executors__card-project modal-delete-executors__card-project_violet'>{data}</div>
                        })}
                    </div>
                </div>}

                <div className='modal-delete-executors__btn-group'>
                    <ButtonBasic
                        grey
                        text='Отменить'
                        onClick={onClose}
                    />

                    <ButtonBasic
                        red
                        disabled={(!checkValues || ((checkValues === 'Передать права') && !executor?.[0]?.id)) && !is_empty_project}
                        text='Удалить'
                        onClick={(e) => {
                            if (checkValues === 'Передать права') {
                                fetchChangeAuthor()
                            } else {
                                deleteMember([currentMember?.id])
                            }
                            onClose()
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalDeleteExecutors }